import script from "./promotion-requirements-on-artemis-ads.vue?vue&type=script&setup=true&lang=js"
export * from "./promotion-requirements-on-artemis-ads.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__